import { apiFetch } from './apiClient';

export interface DashboardResponse {
  metrics: {
    totalSKUs: number;
    inStockCount: number;
    inStockPct: number;
    overpricedCount: number;
    avgMarketPosition: number;
    cheapestSharePct: number;
    totalCompetitorRows: number;
  };
  categoryComposition: { category: string; count: number }[];
  brandComposition: { brand: string; count: number }[];
  crawlerHealth: { company: string; lastCrawlDt: string; errorCount24h: number }[];
  recentShifts: {
    id: number;
    title: string;
    sku: string;
    company: string;
    old_price: number;
    new_price: number;
    direction: 'down' | 'up';
    dt: string;
  }[];
  topMovers: {
    id: number;
    title: string;
    sku: string;
    company: string;
    old_price: number;
    new_price: number;
    pct: number;
    direction: 'down' | 'up';
  }[];
  outOfStockAlerts: { product_id: number; title: string; sku: string; md_sku: string; availableAt: string[] }[];
  topOpportunities: {
    product_id: number;
    title: string;
    sku: string;
    md_price: number;
    lowest_price: number;
    lowest_competitor: string;
    target_drop: number;
  }[];
}

export const dashboardService = (token: string | null) => ({
  get: (days: number, init: RequestInit = {}) =>
    apiFetch<DashboardResponse>(token, `/api/dashboard?days=${days}`, init),
});
